import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IToolPanelParams } from 'ag-grid-community';

export interface ICustomView {
  id: string;
  username: string;
  name: string;
  view: string;
  usage: string;
  isDefault: boolean;
}

export type ICustomViewProps = IToolPanelParams & {
  setQuickFilter(value: string): any;
  useAppDispatch(): any;
  useAppSelector(): any;
  onClearAllFilters?: () => void;
  viewContext?: string;
};

export interface ICustomViewNamesState {
  currentViewId?: string;
  currentView?: ICustomView;
  currentPredefinedFilter?: string;
}

export const initialCustomViewsState: ICustomViewNamesState = {
  currentViewId: undefined,
  currentView: undefined,
  currentPredefinedFilter: undefined,
};

export const customViewsSlice = createSlice({
  name: 'customViews',
  initialState: initialCustomViewsState,
  reducers: {
    setCurrentViewId: (state: any, action) => ({
      ...state,
      currentViewId: action.payload,
    }),
    setCurrentView: (state: any, action: PayloadAction<ICustomView>) => ({
      ...state,
      currentView: action.payload,
    }),
    setCurrentPredefinedFilter: (
      state: any,
      action: PayloadAction<string | undefined>,
    ) => ({
      ...state,
      currentPredefinedFilter: action.payload,
    }),
    resetCustomViews: () => ({
      ...initialCustomViewsState,
      currentViewId: undefined,
    }),
  },
});

export const {
  setCurrentViewId,
  setCurrentView,
  setCurrentPredefinedFilter,
  resetCustomViews,
} = customViewsSlice.actions;

export default customViewsSlice.reducer;
export { default as customViewsReducer } from '@/app/slices/customViews';
